import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { ActivityLogDto } from '../../common/PricePrgClient';

type Props = {
    activityLog: ActivityLogDto;
    onClose(): void;
};

export const ActivityLogDetailsDialog = ({ activityLog, onClose }: Props) => (
    <Dialog onClose={onClose} open={true}>
        <DialogTitle>Details for log {activityLog.id}</DialogTitle>
        <DialogContent>
            <pre style={{ maxHeight: 600, overflowY: 'auto', marginRight: 16 }}>
                {JSON.stringify(JSON.parse(activityLog.logData), null, 2)}
            </pre>
        </DialogContent>
        <DialogActions>
            <Button onClick={onClose} color="primary">
                Close
            </Button>
        </DialogActions>
    </Dialog>
);
